import Vue from 'vue';
import VueRouter from 'vue-router';

import sessionStore from 'store';

// 进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import store from '@/store/index';

import util from '@/libs/util.js';

// 路由数据
import routes from './routes';
import { menuAside, menuHeader } from '@/menuConfig';

Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  routes
});

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async function (to, from, next) {
  // 进度条
  NProgress.start();
  // 关闭搜索面板
  store.commit('d2admin/search/set', false);
  if (to.path === '/login') {
    sessionStore.remove('me');
    sessionStore.remove('app');
    sessionStore.remove('token');
    sessionStore.remove('isSafe');
    store.dispatch('d2admin/page/clear');
    const isSave = sessionStore.get('savePass');
    if (!isSave) {
      sessionStore.remove('account');
    }
  }

  const token = sessionStore.get('token');
  if (!token && to.path !== '/login') {
    next({ path: '/login' });
  } else if (token && to.path !== '/login') {
    await store.dispatch('checkAgentAuth');
    const filterRoute = (list) => {
      return list.filter(item => {
        const menuAuth = item.checkShow || false;
        return !menuAuth || !store.getters.isAgent;
      });
    };
    const header = filterRoute(menuHeader);
    const aside = filterRoute(menuAside);
    store.commit('d2admin/menu/headerSet', header);
    store.commit('d2admin/menu/asideSet', aside);
    store.commit('d2admin/search/init', aside);
    const menuAuth = (to.meta && to.meta.checkAuth) || false;
    const authCheck = !menuAuth || !store.getters.isAgent;
    if (authCheck) {
      const inMenu = aside.filter(item => {
        if (!item.children) return item.path === to.path;
        return item.children.some(kid => kid.path === to.path);
      });
      if (inMenu.length > 0 || to.path === '/hotel' || to.path === '/end-points') {
        next();
      } else {
        next({ path: '/login' });
      }
    } else {
      next({ path: '/login' });
    }
  } else if (to.path === '/login') {
    next();
  } else {
    next({ path: '/login' });
  }
});

router.afterEach(to => {
  // 进度条
  NProgress.done();
  // 多页控制 打开新的页面
  store.dispatch('d2admin/page/open', to);
  // 更改标题
  util.title(to.meta.title);
});

export default router;
